export default [
  {
    title: '策划师',
    key: 'designerName',
    width: 86,
    type: 'basic'
  },
  {
    title: '项目组',
    key: 'projectGroupName',
    width: 98,
    type: 'basic'
  },
  {
    title: '新增视频数',
    key: 'addVideoCount',
    width: 82,
    type: 'basic'
  },
  {
    title: '新增图片数',
    key: 'addImageCount',
    width: 82,
    type: 'basic'
  },
  {
    title: '总消耗金额',
    key: 'amount',
    width: 82,
    type: 'basic'
  },
  {
    title: '新增消耗金额',
    key: 'newAmount',
    width: 95,
    type: 'basic'
  },
  {
    title: '创角成本',
    key: 'createRoleCost',
    width: 74,
    type: 'basic'
  },
  {
    title: '新创角充值金额',
    key: 'newRoleMoney',
    width: 106,
    type: 'basic'
  },
  {
    title: '新创角回款率',
    key: 'newRoleRate',
    width: 95,
    type: 'basic'
  },
  {
    title: '合格完成率',
    key: 'oneLevelRate',
    width: 82,
    type: 'basic'
  },
  {
    title: '优秀完成率',
    key: 'twoLevelRate',
    width: 82,
    type: 'basic'
  },
  {
    title: '卓越完成率',
    key: 'threeLevelRate',
    width: 82,
    type: 'basic'
  },
  {
    title: '超10万消耗素材数',
    key: 'oneLevelAmountCount',
    width: 120,
    type: 'basic'
  },
  {
    title: '超15万消耗素材数',
    key: 'twoLevelAmountCount',
    width: 120,
    type: 'basic'
  },
  {
    title: '超100万消耗素材数',
    key: 'threeLevelAmountCount',
    width: 128,
    type: 'basic'
  },
  {
    title: '新增视频有效率',
    key: 'newImageOkRate',
    width: 106,
    type: 'basic'
  },
  {
    title: '合格KPI',
    key: 'oneLevelKpi',
    width: 72,
    type: 'basic'
  },
  {
    title: '优秀KPI',
    key: 'twoLevelKpi',
    width: 72,
    type: 'basic'
  },
  {
    title: '卓越KPI',
    key: 'threeLevelKpi',
    width: 72,
    type: 'basic'
  }
]
